import React from 'react'
import * as styles from './Grid.module.scss'
import { ArrowRightIcon, TutorialIcon } from '@atlas-co/icons'
import Button from '../common/Button'
import { Link } from 'gatsby'

const Grid = ({ courses }) => {
  const spotlight = courses[0]
  const nextOne = courses[1]

  return (
    <div className={styles.section}>
      <div className={styles.content}>
        <SpotlightCourse spotlight={spotlight} />
        <SpotlightCourse spotlight={nextOne} />
      </div>
    </div>
  )
}

export default Grid

export const SpotlightCourse = ({ spotlight }) => {
  if (!spotlight) return null

  const lessons = spotlight.lessons || []
  const hasLessons = lessons.length > 0

  return (
    <div className={styles.spotlightOuter}>
      <Link to={`/academy/${spotlight.slug.current}/`}>
        <div className={styles.spotlight}>
          <div className={styles.spotlightImage}>
            <img
              src={
                spotlight.featuredImage?.asset?.url ||
                'https://atlas.co/images/academy-og.png'
              }
              alt={spotlight.title}
            />
          </div>
          <div className={styles.spotlightContent}>
            <h2>{spotlight.title}</h2>
            <p>{spotlight.description}</p>
            {hasLessons && (
              <div className={styles.lessonList}>
                {lessons.slice(0, 3).map((lesson, index) => (
                  <Link
                    key={lesson.id || lesson._id || index}
                    to={`/academy/${spotlight.slug.current}/${lesson.slug?.current || lesson.slug}/`}
                  >
                    <div className={styles.lesson}>
                      <TutorialIcon size={28} />
                      <span>{lesson.title}</span>
                    </div>
                  </Link>
                ))}
                {lessons.length > 3 && (
                  <div className={styles.lesson}>
                    <span>+ {lessons.length - 3} more lessons</span>
                  </div>
                )}
              </div>
            )}
            <Button
              href={`/academy/${spotlight.slug.current}/`}
              variant="primary"
              rightIcon={<ArrowRightIcon color="#fff" />}
            >
              Start learning
            </Button>
          </div>
        </div>
      </Link>
    </div>
  )
}

export const GridItem = ({ title, link, short, excerpt, image }) => {
  return (
    <div className={styles.postCard}>
      <div className={styles.cardImage}>
        <img src={image} alt={title} />
      </div>
      <div className={styles.cardContent}>
        <div className={styles.cardDetails}>
          <span>{short}</span>
          <span>12 lessons</span>
        </div>
        <h3>{title}</h3>
        <p>{excerpt}</p>
        <Button
          href="/academy/101"
          variant="primary"
          rightIcon={<ArrowRightIcon color="#fff" />}
        >
          Start learning
        </Button>
      </div>
    </div>
  )
}
